import React, { useCallback, useEffect } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import {
  AcademyTopicInput,
  academyTopicInputSelector,
  classFormSelector,
  NON_LIVE_LECTURE_LESSON_TYPES,
  resetCreateClassForm,
  setAcademyTopicInput,
  setClassType,
  useCreateLectureTemplateMutation,
} from 'features/classCreation';
import Field from 'components/Field';
import Form from 'components/Form';
import LessonInputGroup from '../LessonInputGroup';
import TaSkills from '../TaSkills';

export default function CreateNonLiveLectureClassForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const academyTopicInput = useSelector(academyTopicInputSelector);
  const classForm = useSelector(classFormSelector);
  const [
    createLectureTemplate,
    { isLoading: isCreating, error, isSuccess, data: response },
  ] = useCreateLectureTemplateMutation();

  const handleAcademyTopicInputChange = useCallback(
    (newAcademyTopic) => {
      dispatch(setAcademyTopicInput(newAcademyTopic));
    },
    [dispatch]
  );

  const handleCreateLectureTemplate = useCallback(
    (event) => {
      event.preventDefault();
      createLectureTemplate({ ...classForm, byPassLiveLecture: true });
    },
    [classForm, createLectureTemplate]
  );

  useEffect(() => {
    if (isSuccess) {
      navigate(`/classes/edit-classes/${response.data.id}`);
      batch(() => {
        dispatch(setClassType(null));
        dispatch(resetCreateClassForm());
      });
    }
  }, [dispatch, isSuccess, navigate, response]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        error.data?.message ||
          'Failed to create lecture template, try again after sometime.'
      );
    }
  }, [error]);

  return (
    <Form
      onSubmit={handleCreateLectureTemplate}
      serverErrors={error?.data?.errors}
    >
      <Field
        label="Lecture Activity"
        className="m-b-l"
        name="academy_topic"
        serverErrors={error?.data?.errors}
      >
        <AcademyTopicInput
          value={academyTopicInput}
          onChange={handleAcademyTopicInputChange}
        />
      </Field>
      <TaSkills errors={error?.data?.errors} />
      <LessonInputGroup
        errors={error?.data?.errors}
        allowedLessonTypes={NON_LIVE_LECTURE_LESSON_TYPES}
      />
      <Tappable
        className="btn btn-primary btn-long"
        disabled={isCreating}
        type="submit"
        component="button"
      >
        Create Class
      </Tappable>
    </Form>
  );
}
